import React, { Component } from 'react';


class Network extends Component {

    constructor(props) 
    {
        super(props)

        this.state = {
            network: props.network,
            updateApp: props.updateApp,
            fetchManifestResult: "",
            fetchDataResult: "",
            doi: "",
            defaultValue: "Pick DOI from the list",
        }

        this.handleFetch = this.handleFetch.bind(this)
        this.handleDOIChange = this.handleDOIChange.bind(this)
        this.handleClearDOI = this.handleClearDOI.bind(this)
    }

    handleDOIChange(event)
    {
        this.setState({
            doi: event.target.value
        })
    }

    handleClearDOI() 
     {
       this.setState({
        doi: ""},  () => 
        console.log(this.state.doi));
             }
        
    
    async handleFetch(event)
    {
        let fetchRes = event.target.value

        if ("" === this.state.doi)
        {
            this.setState({
                [fetchRes]: "Empty DOI"
            })

            return
        }

        this.state.network[event.target.name](this.state.doi).then( res => {
            
            this.setState({
                [fetchRes]: res.status
            })

            if ("ok" === res.status)
                this.state.updateApp()
        })
    }

    render()
    
    {

        return (

            <div className="Network p-1 bg-secondary rounded-lg text-white">
            

                    <div className="col-md-12 font-weight-bold p-1">NETWORK</div>
                <div className="col-md-12">
                <select className="form-control alert-success alert-dismissible fade show p-2" 
                id="dois" onChange={this.handleDOIChange} value={this.state.doi}>
                    <option defaultValue>Choose DOI from the list</option>
                    <option value="03FEE1468FF693744FDEFB20D41E793E6A03CFBDD3687901EA99271DCC702DF8">Doi 1 {this.state.doi}</option>
                    <option value="00A66067BD93F5417D9E94858795B6E852EF90DE790C543B1E47A2E009D435F3">Doi 2 {this.state.doi}</option>
                    <option value="0487DEB729ABE42001007D1ADBEF310FE6BCBD308B7A889458F2E1F8B1C5D14E">Doi 3 {this.state.doi}</option>
                </select>
                </div>
               
                   
                                <div  style={{display: this.state.doi ? 'block' : 'none'}}>
                                <div className="col-md-12">
                                <button className="btn btn-sm active btn-secondary m-3" onClick={this.handleFetch} name="search_manifest_by_doi" value="fetchManifestResult">Fetch Manifest</button>

                                <div className="col-md-12 alert alert-success">{this.state.fetchManifestResult}</div></div>
                          
                                <div className="col-md-12"><button className="btn btn-sm active btn-secondary m-3" onClick={this.handleFetch} name="search_data_by_doi" value="fetchDataResult">Fetch Data</button>
                                <div className="col-md-12 alert alert-success" style={{display: this.state.doi ? 'block' : 'none'}}>{this.state.fetchDataResult}</div></div>

                                <div className="col-md-12"><button className="btn btn-sm btn-warning" onClick={this.handleClearDOI} name="clear_DOI">Clear</button> </div>
                                </div>
                          
              </div>                             
              

            
        );
    }
}

export default Network;